<div
  (click)="selectItem()"
  (keypress.enter)="selectItem()"
  (mouseenter)="onItemHover(data)"
  (mouseleave)="onItemLeave()"
  (focus)="onItemFocus($event, data)"
  (focusout)="onItemHover()"
  [ngClass]="{'!bg-white !text-black': isSelected()}"
  class="text-white card card-mini bg-white/10 w-full transition group hover:bg-white/30 cursor-pointer"
  tabindex="0"
  >
  <div class="justify-between origin-left transition flex gap-2 items-center">

    <!-- TITLE -->
    <span class="group-hover:scale-95 truncate text-sm lg:text-xs">{{ data.title }}</span>

    <!-- 3D VIEW ICON -->
    @if (data.is3dView) {
      <img src="assets/img/icons/360-view.svg" alt="360 View">
    }

    <!-- ARROW -->
    @if (hasChildren){
      <i class="transition-transform group-hover:scale" [class]="{'-rotate-90': isOpen}">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3">
          <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
        </svg>
      </i>
    }

  </div>

</div>

<!-- RECURSIVE CHILDREN -->
@if(hasChildren && isOpen) {
  <div class="pl-4 mt-2 border-l border-white/20 flex flex-col gap-y-1.5">
    @for (child of data.children; track child) {
      <app-menu-item [item]="child"/>
    }
  </div>
}